export default {
  en: {
    columns: {
      title: 'Title',
      message: 'Message',
      viewedBy: 'Viewed by',
      createdBy: 'Created by',
      publishAt: 'Published date',
    },
    form: {
      title: {
        label: 'Notification title',
        hint: 'Short notification title',
      },
      body: {
        label: 'Message',
        hint: 'Message will send to the agents'
      },
      publishedAt: {
        title: 'Publish date',
        hint: 'Date on which the notification will be published',
        placeholder: 'Select a date'
      },
    },
    alert: 'If the notification date is in the past it will be sent immediately'
  },
  es: {
    columns: {
      title: 'Título',
      message: 'Mensaje',
      viewedBy: 'Visto por',
      createdBy: 'Creado por',
      publishAt: 'Fecha de publicación',
    },
    form: {
      title: {
        label: 'Título de la notificación',
        hint: 'Título de notificación breve',
      },
      body: {
        label: 'Mensaje',
        hint: 'El mensaje será enviado a las agentes'
      },
      publishedAt: {
        title: 'Fecha para publicar',
        hint: 'Fecha en la que se publicará la notificación',
        placeholder: 'Selecciona una fecha'
      },
    },
    alert: 'Si la fecha de la notificación está en el pasado se enviará inmediatamente'
  },
  fr: {
    columns: {
      title: 'Titre',
      message: 'Message',
      viewedBy: 'Vu par',
      createdBy: 'Créé par',
      publishAt: 'Date de publication',
    },
    form: {
      title: {
        label: 'Titre de la notification',
        hint: 'Titre bref de la notification',
      },
      body: {
        label: 'Message',
        hint: 'Le message sera envoyé aux agents'
      },
      publishedAt: {
        title: 'Date de publication',
        hint: 'Date à laquelle la notification sera publiée',
        placeholder: 'Sélectionnez une date'
      },
    },
    alert: 'Si la date de la notification est dans le passé, elle sera envoyée immédiatement'
}

}
